<template>
	<div class="client-2">
		<ul id="client-2">
			<li class="my-kefu-qq">
				<a class="online-contact-btn" href="javascript:void(0);" onclick="window.open('http://p.qiao.baidu.com/cps/chat?siteId=14085450&userId=1052055', 'newwindow', 'height=600, width=800,top=50,left=350');return false;">
					<i>
						<img src="../../assets/images/client-icon1.png" alt />
					</i>
					<p>售前咨询</p>
				</a>
			</li>
			<li class="my-kefu-qq">
				<a class="online-contact-btn" href="javascript:void(0);" onclick="window.open('http://p.qiao.baidu.com/cps/chat?siteId=14085450&userId=1052055', 'newwindow', 'height=600, width=800,top=50,left=350');return false;" target="_blank">
					<i>
						<img src="../../assets/images/client-icon6.png" alt />
					</i>
					<p>售后客服</p>
				</a>
			</li>
			<li class="my-kefu-qq">
				<a class="online-contact-btn" href="/agent.html" target="_blank">
					<i>
						<img src="../../assets/images/client-icon2.png" alt />
					</i>
					<p>代理</p>
				</a>
			</li>
			<li class="my-kefu-qq">
				<a class="online-contact-btn" href="http://help.web724.cn/" target="_blank">
					<i>
						<img src="../../assets/images/client-icon3.png" alt />
					</i>
					<p>帮助</p>
				</a>
			</li>
			<li class="my-kefu-ftop" @click="backTop" v-if="btnFlag">
				<a href="javascript:;">
					<i>
						<img src="../../assets/images/client-icon5.png" alt />
					</i>
					<p>顶部</p>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import EventBus from '@/eventBus'
export default {
	name: 'rightHelp',
	data () {
		return {
			btnFlag: false,
			routeName: '',
			scrollBox: null
		}
	},
	watch: {
		'$route.name': {
			handler (val, oldVal) {
				this.routeName = val
			},
			immediate: true
		}
	},
	mounted () {
		window.addEventListener('scroll', this.scrollToTop)
		EventBus.$on('zcoolScroll', (top, scrollBox, baseTop) => {
			this.btnFlag = top !== baseTop
			this.scrollBox = scrollBox
		})
	},
	destroyed () {

		window.removeEventListener('scroll', this.scrollToTop)
	},
	methods: {
		// 点击图片回到顶部方法，加计时器是为了过渡顺滑
		backTop () {
			if (this.routeName !== 'zcool' && this.routeName !== 'pic-record') {
				const that = this
				let timer = setInterval(() => {
					let ispeed = Math.floor(-that.scrollTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed

					if (that.scrollTop === 0) {
						clearInterval(timer)
					}
				}, 16)
			} else if (this.routeName === 'zcool' || this.routeName === 'pic-record') {

				this.scrollBox.scrollTop = 0

			}
		},
		// 计算距离顶部的高度，控制顶部图标显示隐藏
		scrollToTop () {
			const that = this
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			that.scrollTop = scrollTop
			if (that.scrollTop > 0) {
				that.btnFlag = true
			} else {
				that.btnFlag = false
			}

		},
	}
}
</script>

<style lang="scss" scoped>
.client-2 {
	position: fixed;
	right: 0;
	top: 50%;
	z-index: 9999;
	width: 68px;
	margin-top: -160px;
}
.client-2 li a {
	text-decoration: none;
}
.client-2 li {
	clear: both;
	background: #e18731;
	width: 68px;
	height: 80px;
	position: relative;
	padding: 14px 0 0;
	border-top: 1px solid #fff;
}
.client-2 li:first-child {
	border-top: none;
}

.client-2 li p {
	height: 20px;
	font-size: 12px;
	line-height: 20px;
	overflow: hidden;
	text-align: center;
	color: #fff;
}
.client-2 li i,
.client-2 li i img {
	width: 30px;
	height: 30px;
	display: block;
	margin: 0px auto;
	text-align: center;
}
</style>
